const loadMoreBtn = [...document.querySelectorAll('.btn-load-more')];
/**
 * Show items
 */
function setDefLoadMoreItem() {
  const wrapItemShow = [...document.querySelectorAll('.grid-load-more')];

  wrapItemShow.forEach((listIndex) => {
    const numberShowItem = listIndex.getAttribute('data-set');
    const getBlockItem = [...listIndex.querySelectorAll('.text p')];
    const setDefaultElements = getBlockItem.slice(0, numberShowItem);

    setDefaultElements.forEach((indexTarget) => {
      indexTarget.classList.add('grid-load-more--show');
    });
  });
}

const loadMore = {
  init() {
    setDefLoadMoreItem();

    loadMoreBtn.forEach((loadBtn) => {
      let numShow = Number(loadBtn.parentNode.parentNode.parentNode.querySelector('.grid-load-more').getAttribute('data-set'));

      loadBtn.addEventListener('click', (event) => {
        event.preventDefault();
        const numberAddItem = Number(event.target.getAttribute('data-add'));
        const defElementListLoadMore = [...event.target.parentNode.parentNode.querySelectorAll('.text p')];

        for (let i = numShow; i < numShow + numberAddItem; i++) {
          if (defElementListLoadMore[i]) {
            defElementListLoadMore[i].classList.add('grid-load-more--show');
          }
        }
        const lastActive = [...event.target.parentNode.parentNode.querySelectorAll('.text .grid-load-more--show')];
        const lastItem = lastActive[lastActive.length - 1];
        // const lastItemTop = lastItem.getBoundingClientRect().top;
        // const test = event.target.getBoundingClientRect().top;
        numShow += numberAddItem;
        lastItem.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });

        // Load more button will be hidden after list fully loaded
        if (numShow >= defElementListLoadMore.length) {
          event.target.parentNode.style.display = 'none';
        }
      });
    });
  },
};

export default loadMore;
